import minussquare from "@src/assets/icons/minussquare.png";
import plussquare from "@src/assets/icons/plussquare.png";
import {
  columnTypes,
  paginationGridOptions,
  preventPinnedColumnJumpingGridOption,
} from "@src/utils/aggrid_utils";

import { defaultFTEColDefs } from "./resource_planner_utils";

const getFullWidthRowHeight = (proposedData) => {
  if (
    proposedData.proposedYearlyAllocations &&
    Object.keys(proposedData.proposedYearlyAllocations).length > 0 &&
    !proposedData.isOutdated
  ) {
    return 900;
  }
  return 520;
};

export const requestRepliesOptions = {
  ...paginationGridOptions,
  ...preventPinnedColumnJumpingGridOption,
  suppressContextMenu: true,
  domLayout: "autoHeight",
  groupUseEntireRow: true,
  icons: {
    groupExpanded: `<img src=${minussquare} style="height: 25px; width: 25px;padding-right: 2px"/>`,
    groupContracted: `<img src=${plussquare} style="height: 25px; width: 25px;padding-right: 2px"/>`,
  },
  alwaysAggregateAtRootLevel: true,
  defaultColDef: {
    ...columnTypes.default,
    ...defaultFTEColDefs,
    flex: 1,
    autoHeaderHeight: true,
    resizable: false,
  },
  getRowClass: (params) => {
    if (
      params.data.status === "Declined" ||
      params.data.status === "Proposed" ||
      params.node.rowPinned
    ) {
      return `row-status-bold`;
    }
  },
  getRowHeight: (params) => {
    if (params.node.detail) {
      return getFullWidthRowHeight(params.node.data);
    } else {
      return 55;
    }
  },
};
